import React, { useMemo, useState } from 'react';
import { FaBroadcastTower, FaBuilding, FaChartLine, FaCircle, FaCertificate, FaMapMarkerAlt, FaMoneyBillWave, FaProjectDiagram, FaShieldAlt, FaTachometerAlt, FaUsers, FaUserGraduate, FaUserTag, FaEye, FaUserCog, FaUpload, FaPlus, FaCalendarAlt, FaRegCalendarCheck, FaRegClock, FaRupeeSign, FaGraduationCap, FaBell, FaPaperPlane, FaBullhorn, FaFileAlt, FaCog, FaClipboardList, FaCheckDouble } from 'react-icons/fa';
import { FiHome, FiSettings, FiX, FiChevronDown, FiMenu, FiChevronRight, FiMessageSquare, FiTool } from 'react-icons/fi';
import { FaIndianRupeeSign } from "react-icons/fa6";
import { CiViewBoard } from "react-icons/ci";
import { IoCarSharp } from "react-icons/io5";
import { LuSettings } from 'react-icons/lu';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { useAuth } from '../../provider/auth.provider';
import { MdOutlineWork } from 'react-icons/md';
import { MdOutlinePaid } from 'react-icons/md';
import { TbReportAnalytics } from 'react-icons/tb';
import { MdOutlineReceiptLong } from 'react-icons/md';
import { MdAccessTime } from 'react-icons/md';
import { FaWarehouse, FaDolly, FaFileInvoiceDollar, FaClipboardCheck, FaRecycle, FaStream, FaBalanceScale, FaDraftingCompass } from 'react-icons/fa';

interface SidebarProps {
  collapsed: boolean;
  mobileOpen: boolean;
  onToggleCollapse: () => void;
  onCloseMobile: () => void;
  onLogout: () => void;
}

interface MenuItem {
  icon?: React.ComponentType<any>;
  label: string;
  path?: string;
  children?: MenuItem[];
  requiredPermission?: { resource: string; action: string };
  requiredAnyPermissions?: Array<{ resource: string; action: string }>;
  isHeading?: boolean;
  isStandalone?: boolean;
}

// Menu with permission requirements
const menu: MenuItem[] = [
  {
    icon: FiHome,
    label: 'Dashboard',
    path: '/dashboard',
    isStandalone: true,
  },

  // 🔹 Operations Heading
  {
    icon: MdOutlineWork,
    label: 'Operations',
    isHeading: true
  },
  {
    icon: FaBroadcastTower,
    label: 'Survey',
    children: [
      {
        icon: FaProjectDiagram,
        label: 'Project Sites',
        path: '/sites/project-sites',
        requiredPermission: { resource: 'Site', action: 'view_all' }
      },
      {
        icon: FaEye,
        label: 'My Sites',
        path: '/sites/my-sites',
        requiredAnyPermissions: [
          { resource: 'Site', action: 'view_my' },
          { resource: 'Site', action: 'view_all' },
          { resource: 'Site', action: 'assign' },
          { resource: 'Site', action: 're_assign' },
          { resource: 'Site', action: 'upload' },
          { resource: 'Site', action: 'create' },
          { resource: 'Site', action: 'map_view' },
          { resource: 'Site', action: 'mis' },
          { resource: 'Site', action: 'cancel' },
          { resource: 'Site', action: 'hold' },
          { resource: 'Site', action: 'view' },
          { resource: 'Site', action: 'validator' },
          { resource: 'Site', action: 'gallery_upload' },
        ]
      },
      {
        icon: FaUserCog,
        label: 'Assign Sites',
        path: '/sites/assign',
        requiredPermission: { resource: 'Site', action: 'assign' }
      },
      {
        icon: FaClipboardList,
        label: 'Assign Request',
        path: '/sites/requested',
        requiredPermission: { resource: 'Site', action: 'site_requests_view' }
      },
      {
        icon: FaUpload,
        label: 'Multiple Site Creation',
        path: '/sites/upload',
        requiredPermission: { resource: 'Site', action: 'upload' }
      },
      {
        icon: FaMapMarkerAlt,
        label: 'Map view',
        path: '/map-view',
        requiredPermission: { resource: 'Site', action: 'map_view' }
      },
      {
        icon: FaPlus,
        label: 'Single Site Creation',
        path: '/sites/create',
        requiredPermission: { resource: 'Site', action: 'create' }
      }
    ]
  },
  {
    icon: FiTool,
    label: 'INC',
    children: [
      // {
      //   icon: FaTachometerAlt,
      //   label: 'INC Dashboard',
      //   path: '/inc/dashboard',
      //   requiredAnyPermissions: [
      //     { resource: 'IncSite', action: 'view_all' },
      //     { resource: 'IncSite', action: 'view' },
      //   ]
      // },
      {
        icon: FaProjectDiagram,
        label: 'INC Sites',
        path: '/inc/sites',
        requiredPermission: { resource: 'IncSite', action: 'view_all' }
      },
      {
        icon: FaEye,
        label: 'My INC Sites',
        path: '/inc/my-sites',
        requiredAnyPermissions: [
          { resource: 'IncSite', action: 'view' },
          { resource: 'IncSite', action: 'view_all' },
          { resource: 'IncSite', action: 'create' },
          { resource: 'IncSite', action: 'edit' },
          { resource: 'IncSite', action: 'assign' },
          { resource: 'IncSite', action: 'upload' },
        ]
      },
      {
        icon: FaPlus,
        label: 'Single Site Creation',
        path: '/inc/create',
        requiredPermission: { resource: 'IncSite', action: 'create' }
      },
      {
        icon: FaUpload,
        label: 'Multiple Site Creation',
        path: '/inc/upload',
        requiredPermission: { resource: 'IncSite', action: 'upload' }
      }
    ]
  },
  {
    icon: FaDraftingCompass,
    label: 'Designing',
    children: [
      {
        icon: FaProjectDiagram,
        label: 'Project Sites',
        path: '/designing/sites',
        requiredPermission: { resource: 'DesignSite', action: 'view_all' }
      },
      {
        icon: FaEye,
        label: 'My Sites',
        path: '/designing/my-sites',
        requiredPermission: { resource: 'DesignSite', action: 'view_my' }
      },
      {
        icon: FaUpload,
        label: 'Multiple Site Creation',
        path: '/designing/upload',
        requiredPermission: { resource: 'DesignSite', action: 'upload' }
      },
      {
        icon: FaPlus,
        label: 'Single Site Creation',
        path: '/designing/create',
        requiredPermission: { resource: 'DesignSite', action: 'create' }
      }
    ]
  },
{
  icon: FaProjectDiagram,
  label: 'Project Requirment',
  path: '/requirements/project-specific',
  requiredPermission: {
    resource: 'OperationsRequirementsProjectActivity',
    action: 'view_project_specific',
  },
},

  // 🔹 Material Management Heading
  // A top-level section in its own right, at the same level as Operations and Billing.
  {
    icon: FaWarehouse,
    label: 'Material Management',
    isHeading: true
  },
  // Ordered along the life of a piece of material, not alphabetically: request
  // -> arrange and pay -> issue -> consume -> write off, then where things
  // stand, then the masters.
  {
    icon: FaClipboardList,
    label: 'Material Requests (MRN)',
    path: '/materials/requests',
    requiredPermission: { resource: 'MaterialRequest', action: 'view_all' }
  },
  {
    icon: FaFileInvoiceDollar,
    label: 'Arrangement & Payment',
    path: '/materials/arrangements',
    requiredPermission: { resource: 'MaterialArrangement', action: 'view_all' }
  },
  {
    icon: FaDolly,
    label: 'Issue Notes (MIN)',
    path: '/materials/issues',
    requiredPermission: { resource: 'MaterialIssue', action: 'view_all' }
  },
  {
    icon: FaClipboardCheck,
    label: 'Consumption (MCR)',
    path: '/materials/consumptions',
    requiredPermission: { resource: 'MaterialConsumption', action: 'view_all' }
  },
  {
    icon: FaRecycle,
    label: 'Scrap, Sale & Loss',
    path: '/materials/scraps',
    requiredPermission: { resource: 'MaterialScrap', action: 'view_all' }
  },
  {
    icon: FaStream,
    label: 'Stock & Ledger',
    path: '/materials/stock',
    requiredPermission: { resource: 'MaterialInventory', action: 'view_balances' }
  },
  {
    icon: FaBalanceScale,
    label: 'Reconciliation',
    path: '/materials/reco',
    requiredPermission: { resource: 'MaterialReco', action: 'view' }
  },
  // Opening Balances and the material masters (Warehouses, Suppliers,
  // Transporters, Items, Classification, Units, Cost Categories) live on the
  // Masters page, each card gated by the same view_all permission.

  // 🔹 Expense Heading
  {
    icon: FaRupeeSign,
    label: 'Expense',
    isHeading: true
  },
  {
    icon: AiOutlineFundProjectionScreen,
    label: 'Project Claims',
    path: '/claims/project',
    requiredPermission: { resource: 'project_claim', action: 'view_all' }
  },
  {
    icon: CiViewBoard,
    label: 'General Claims',
    path: '/claims/general',
    requiredPermission: { resource: 'general_claim', action: 'view_all' }
  },
  {
    icon: FaIndianRupeeSign,
    label: 'Advance',
    path: '/claims/advance',
    requiredAnyPermissions: [
      { resource: 'advance_claim', action: 'view_all' },
      { resource: 'advance_claim', action: 'submit' },
      { resource: 'advance_claim', action: 'approve' }
    ]
  },
  {
    icon: FaShieldAlt,
    label: 'Advance Restrictions',
    path: '/claims/advance/restrictions',
    requiredPermission: { resource: 'advance_claim', action: 'approve' }
  },
  {
    icon: IoCarSharp,
    label: 'Cab Hiring',
    path: '/claims/cab-hiring',
    requiredPermission: { resource: 'cab_claim', action: 'read_all' }
  },

  // 🔹 Supplier Heading
  {
    icon: FaBuilding,
    label: 'Supplier',
    isHeading: true
  },
  {
    icon: FaBuilding,
    label: 'Supplier Payment',
    path: '/claims/supplier-payment',
    requiredAnyPermissions: [
      { resource: 'supplier_payment', action: 'view_all' },
      { resource: 'supplier_payment', action: 'view_own' },
      { resource: 'supplier_payment', action: 'create' },
      { resource: 'supplier_payment', action: 'approve' }
    ]
  },
  {
    icon: FaShieldAlt,
    label: 'SP Restrictions',
    path: '/claims/supplier-payment/restrictions',
    requiredPermission: { resource: 'supplier_payment', action: 'manage_restrictions' }
  },

  // 🔹 Billing Heading
  {
    icon: MdOutlineReceiptLong,
    label: 'Billing',
    isHeading: true
  },
  {
    icon: AiOutlineFundProjectionScreen,
    label: 'Billings Done',
    path: '/billings',
    requiredPermission: { resource: 'Billing', action: 'view_stats' }
  },
  {
    icon: CiViewBoard,
    label: 'Billings Pending',
    path: '/billings/pending-sites',
    requiredPermission: { resource: 'Billing', action: 'view_eligible_sites' }
  },
  // Invoice Item Master lives on the Masters page (Vendor Invoice Items card),
  // so it is intentionally not duplicated here under Billing.

  // 🔹 Vendor Invoicing Heading
  // Vendor work acceptance, invoice acceptance and POs have their own
  // VendorInvoicing permissions, separate from Billing.
  {
    icon: MdOutlinePaid,
    label: 'Vendor Invoicing',
    isHeading: true
  },
  {
    icon: MdOutlineWork,
    label: 'Vendor Work Acceptance',
    requiredPermission: { resource: 'VendorInvoicing', action: 'view_vendor_work_acceptance' },
    children: [
      {
        icon: MdOutlineWork,
        label: 'Field Work Sites',
        path: '/billings/vendor-work-acceptance/field-work',
        requiredPermission: { resource: 'VendorInvoicing', action: 'view_vendor_work_acceptance' }
      },
      {
        icon: MdOutlineWork,
        label: 'Report Prep Sites',
        path: '/billings/vendor-work-acceptance/report-prep',
        requiredPermission: { resource: 'VendorInvoicing', action: 'view_vendor_work_acceptance' }
      },
      {
        icon: MdOutlineWork,
        label: 'Complete Sites',
        path: '/billings/vendor-work-acceptance/complete',
        requiredPermission: { resource: 'VendorInvoicing', action: 'view_vendor_work_acceptance' }
      }
    ]
  },
  {
    icon: MdOutlinePaid,
    label: 'Vendor Invoice Acceptance',
    path: '/billings/vendor-invoice-acceptance',
    requiredPermission: { resource: 'VendorInvoicing', action: 'accept_vendor_invoice' }
  },
  {
    icon: MdOutlineReceiptLong,
    label: 'PO Issued',
    path: '/billings/po-issued',
    requiredPermission: { resource: 'VendorInvoicing', action: 'view_po_issued' }
  },

  // 🔹 Time Heading
  {
    icon: MdAccessTime,
    label: 'Attendance/Leaves',
    isHeading: true
  },
  {
    icon: FaRegClock,
    label: 'Attendance',
    children: [
      {
        icon: FaEye,
        label: 'My',
        path: '/attendance/my',
        requiredPermission: { resource: 'attendance', action: 'view_my' }
      },
      {
        icon: FaUsers,
        label: 'Direct Team',
        path: '/attendance/team',
        requiredAnyPermissions: [
          { resource: 'attendance', action: 'view_team' },
          { resource: 'attendance', action: 'view_all' }
        ]
      },
      {
        icon: FaProjectDiagram,
        label: 'All Team',
        path: '/attendance/project-team',
        requiredAnyPermissions: [
          { resource: 'attendance', action: 'view_project_team' },
          { resource: 'attendance', action: 'view_all' }
        ]
      },
      {
        icon: FaUsers,
        label: 'Team Member',
        path: '/attendance/project-team-members',
        requiredAnyPermissions: [
          { resource: 'attendance', action: 'view_project_team' },
          { resource: 'attendance', action: 'view_all' }
        ]
      },
      {
        // Manual marks made by the user and their reporting hierarchy. Viewing
        // and verifying are separate permissions (approve_verifications gates
        // the Verify / Reject and bulk actions inside the page).
        icon: FaClipboardCheck,
        label: 'Verifications',
        path: '/attendance/verifications',
        requiredPermission: { resource: 'attendance', action: 'view_verifications' }
      }
    ]
  },
  {
    icon: FaCalendarAlt,
    label: 'Leaves',
    children: [
      {
        // Leave used / balance per employee in the user's reporting hierarchy.
        icon: FaTachometerAlt,
        label: 'Dashboard',
        path: '/leaves/dashboard',
        requiredPermission: { resource: 'leave', action: 'view_dashboard' }
      },
      {
        icon: FaClipboardList,
        label: 'List',
        path: '/leaves',
        requiredPermission: { resource: 'leave', action: 'view_all' }
      },
      {
        icon: FaRegCalendarCheck,
        label: 'Holiday Calendar',
        path: '/calendar',
        requiredPermission: { resource: 'calendar', action: 'view_all' }
      }
    ]
  },

  // 🔹 Training Heading
  {
    icon: FaGraduationCap,
    label: 'Training',
    isHeading: true
  },
  {
    icon: FaCertificate,
    label: 'Requests',
    path: '/training/requests',
    requiredPermission: { resource: 'TrainingRequest', action: 'view_all' }
  },
  {
    icon: FaMoneyBillWave,
    label: 'Payments',
    path: '/training/payments',
    requiredPermission: { resource: 'TrainingPayment', action: 'view_all' }
  },
  {
    icon: FaUserGraduate,
    label: 'Certified',
    path: '/training/certifications',
    requiredPermission: { resource: 'TrainingCertification', action: 'view_all' }
  },

  // 🔹 Notifications Heading
  {
    icon: FaBell,
    label: 'Notifications',
    isHeading: true
  },
  {
    icon: FaPaperPlane,
    label: 'Templates',
    path: '/templates',
    requiredPermission: { resource: 'notification_template', action: 'view_all' }
  },
  {
    icon: FaBullhorn,
    label: 'Manage Notifications',
    path: '/notifications/manage',
    requiredAnyPermissions: [
      { resource: 'notification', action: 'send' },
      { resource: 'notification', action: 'broadcast' },
      { resource: 'notification', action: 'view_history' }
    ]
  },
  {
    icon: FiMessageSquare,
    label: 'Ticketing',
    isHeading: true
  },
  {
    icon: FiMessageSquare,
    label: 'Raise Ticket',
    path: '/tickets/raise',
    requiredPermission: { resource: 'ticket', action: 'view_my' }
  },
  {
    icon: FiTool,
    label: 'Ticket Actions',
    path: '/tickets/actions',
    requiredPermission: { resource: 'ticket', action: 'view_all' }
  },

  // 🔹 Vendor Portal Heading
  {
    icon: FaBuilding,
    label: 'Vendor Portal',
    isHeading: true
  },
  {
    icon: FaBroadcastTower,
    label: 'Sites',
    requiredPermission: { resource: 'VendorPortal', action: 'view_sites' },
    children: [
      {
        icon: FaMapMarkerAlt,
        label: 'Field Work Sites',
        path: '/vendor-portal/field-work-sites',
      },
      {
        icon: FaFileAlt,
        label: 'Report Preparation Sites',
        path: '/vendor-portal/report-sites',
      },
      {
        icon: FaCheckDouble,
        label: 'Complete Sites',
        path: '/vendor-portal/complete-sites',
      },
    ]
  },
  {
    icon: FaUsers,
    label: 'Team',
    path: '/vendor-portal/team',
    requiredPermission: { resource: 'VendorPortal', action: 'manage_team' }
  },
  // {
  //   icon: FaMoneyBillWave,
  //   label: 'Billing',
  //   path: '/vendor-portal/billings',
  //   requiredPermission: { resource: 'VendorPortal', action: 'view_billing' }
  // },
  {
    icon: MdOutlineReceiptLong,
    label: 'Purchase Orders',
    path: '/vendor-portal/invoices',
    requiredPermission: { resource: 'VendorPortal', action: 'view_invoices' }
  },
  {
    icon: MdOutlinePaid,
    label: 'Invoice Site List',
    requiredPermission: { resource: 'VendorPortal', action: 'view_invoices' },
    children: [
      {
        icon: FaMapMarkerAlt,
        label: 'Field Work',
        path: '/vendor-portal/site-invoices/field-work',
      },
      {
        icon: FaFileAlt,
        label: 'Report Preparation',
        path: '/vendor-portal/site-invoices/report-preparation',
      },
      {
        icon: MdOutlineReceiptLong,
        label: 'Complete Site Invoices',
        path: '/vendor-portal/site-invoices/complete',
      },
    ]
  },
  {
    icon: MdOutlineReceiptLong,
    label: 'Submitted Invoices',
    path: '/vendor-portal/submitted-invoices',
    requiredPermission: { resource: 'VendorPortal', action: 'view_invoices' }
  },

  // 🔹 Human Resource Heading

  {
    icon: FaUsers,
    label: 'Human Resource',
    isHeading: true
  },
  {
    icon: FaUserTag,
    label: 'Users',
    path: '/team',
    requiredPermission: { resource: 'Team', action: 'view_all' }
  },
  {
    icon: FaUserTag,
    label: 'User Details',
    path: '/hr/user-details',
    requiredPermission: { resource: 'user_details', action: 'view_all' }
  },
  {
    icon: FaUsers,
    label: 'User Attendance',
    path: '/attendance/all-users',
    requiredPermission: { resource: 'Human Resource', action: 'user_attendance' }
  },
  {
    icon: FaClipboardCheck,
    label: 'Attendance Verifications',
    path: '/hr/attendance-verifications',
    requiredPermission: { resource: 'Human Resource', action: 'attendance_verifications' }
  },
  {
    icon: FaCalendarAlt,
    label: 'Leave View',
    path: '/hr/leaves',
    requiredPermission: { resource: 'Human Resource', action: 'leave_view' }
  },
  {
    icon: FaUserTag,
    label: 'User Registration',
    path: '/hr/user-registration',
    requiredPermission: { resource: 'Human Resource', action: 'user_registration' }
  },
  {
    icon: LuSettings,
    label: 'Masters',
    path: '/masters',
    requiredAnyPermissions: [
      { resource: 'Role', action: 'view_all' },
      { resource: 'StateCircle', action: 'view_all' },
      { resource: 'Designation', action: 'view_all' },
      { resource: 'Department', action: 'view_all' },
      { resource: 'Client', action: 'view_all' },
      { resource: 'ClientProject', action: 'view_all' },
      { resource: 'Activity', action: 'view_all' },
      { resource: 'VendorManagement', action: 'view_all' },
      { resource: 'Project', action: 'view_all' },
      { resource: 'TrainingInstitute', action: 'view_all' },
      { resource: 'TrainingType', action: 'view_all' },
      { resource: 'AppVersion', action: 'view_all' },
      { resource: 'VendorInvoiceItem', action: 'view_all' },
      { resource: 'MaterialOpeningBalance', action: 'view_all' },
      { resource: 'MaterialWarehouse', action: 'view_all' },
      { resource: 'MaterialSupplier', action: 'view_all' },
      { resource: 'MaterialTransporter', action: 'view_all' },
      { resource: 'MaterialItem', action: 'view_all' },
      { resource: 'MaterialClassificationCategory', action: 'view_all' },
      { resource: 'MaterialClassificationSubCategory', action: 'view_all' },
      { resource: 'MaterialUnit', action: 'view_all' },
      { resource: 'MaterialCostCategory', action: 'view_all' },
      { resource: 'attendance', action: 'manage_manual_mark_settings' }
    ],
    isStandalone: true,
  },

  // 🔹 Reports Heading
  {
    icon: TbReportAnalytics,
    label: 'Reports',
    path: '/reports',
    // Every report permission — the entry is a directory of whatever the
    // caller can open. Keep in step with REPORT_PERMISSIONS in App.tsx.
    requiredAnyPermissions: [
      { resource: 'reports', action: 'view_project_claim_report' },
      { resource: 'reports', action: 'view_cab_hiring_claim_report' },
      { resource: 'reports', action: 'view_general_claim_report' },
      { resource: 'reports', action: 'view_advance_claim_report' },
      { resource: 'reports', action: 'view_site_report' },
      { resource: 'reports', action: 'view_site_distance_report' },
      { resource: 'reports', action: 'view_daily_travel_report' },
      { resource: 'reports', action: 'view_survey_workflow_report' },
      { resource: 'reports', action: 'view_users_report' },
      { resource: 'reports', action: 'view_login_report' },
      { resource: 'reports', action: 'view_password_report' },
      { resource: 'reports', action: 'view_permission_report' },
      { resource: 'reports', action: 'view_client_view_report' },
      { resource: 'reports', action: 'view_site_location_report' },
      { resource: 'reports', action: 'view_site_fw_start_report' },
      { resource: 'reports', action: 'view_reporting_checkin_report' },
      { resource: 'reports', action: 'view_user_productivity_report' },
      { resource: 'reports', action: 'view_site_distance_report_without_km' },
    ],
    isStandalone: true,
  },
];

// Skeleton component for loading state
const MenuSkeleton = () => (
  <div className="space-y-1 px-3">
    {[...Array(8)].map((_, index) => (
      <div key={index} className="animate-pulse flex items-center space-x-3 px-3 py-2.5 rounded-lg">
        <div className="w-[18px] h-[18px] bg-gray-200 rounded" />
        <div className="flex-1 h-4 bg-gray-200 rounded" />
      </div>
    ))}
  </div>
);

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  mobileOpen,
  onToggleCollapse,
  onCloseMobile,
  onLogout
}) => {
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);
  const [expandedHeadings, setExpandedHeadings] = useState<string[]>(['Operations']);
  const location = useLocation();
  const { loading, hasPermission, user } = useAuth();

  // Filter menu items based on permissions
  const filteredMenuItems = useMemo(() => {
    if (loading || !user) return [];

    const filterMenuItems = (items: MenuItem[]): MenuItem[] => {
      const filtered: MenuItem[] = [];
      let currentHeading: MenuItem | null = null;
      let itemsAfterHeading: MenuItem[] = [];
      const filterChildItems = (children: MenuItem[]): MenuItem[] => {
        return children.reduce<MenuItem[]>((acc, child) => {
          const filteredChildren = child.children?.length ? filterChildItems(child.children) : [];
          const shouldShowChild =
            (!child.requiredPermission && !child.requiredAnyPermissions?.length) ||
            hasMenuPermission(child) ||
            filteredChildren.length > 0;

          if (!shouldShowChild) {
            return acc;
          }

          acc.push({
            ...child,
            ...(filteredChildren.length > 0 ? { children: filteredChildren } : {}),
          });
          return acc;
        }, []);
      };

      const hasMenuPermission = (item: MenuItem): boolean => {
        const hasSinglePermission = item.requiredPermission
          ? hasPermission(item.requiredPermission.resource, item.requiredPermission.action)
          : false;
        const hasAnyPermission = item.requiredAnyPermissions?.some((permission) =>
          hasPermission(permission.resource, permission.action)
        ) ?? false;
        return hasSinglePermission || hasAnyPermission;
      };

      for (const item of items) {
        if (item.isHeading) {
          if (currentHeading) {
            if (itemsAfterHeading.length > 0) {
              filtered.push(currentHeading);
              filtered.push(...itemsAfterHeading);
            }
          }
          currentHeading = item;
          itemsAfterHeading = [];
          continue;
        }

        // Standalone items flush any heading buffer and respect permissions when configured
        if (item.isStandalone) {
          if (currentHeading && itemsAfterHeading.length > 0) {
            filtered.push(currentHeading);
            filtered.push(...itemsAfterHeading);
            itemsAfterHeading = [];
          }
          currentHeading = null;
          const shouldShowStandalone = !item.requiredPermission && !item.requiredAnyPermissions?.length
            ? true
            : hasMenuPermission(item);

          if (shouldShowStandalone) {
            filtered.push(item);
          }
          continue;
        }

        // If no permission is required, add the item directly to filtered (for items before any heading)
        if (!item.requiredPermission && !item.requiredAnyPermissions?.length && !currentHeading) {
          filtered.push(item);
          continue;
        }

        if (currentHeading) {
          // If no permission is required, show the item (but still filter its children)
          if (!item.requiredPermission && !item.requiredAnyPermissions?.length) {
            if (item.children?.length) {
              const filteredChildren = filterChildItems(item.children);
              if (filteredChildren.length > 0) {
                itemsAfterHeading.push({ ...item, children: filteredChildren });
              }
            } else {
              itemsAfterHeading.push(item);
            }
            continue;
          }

          // Check if user has the required permission
          const hasRequiredPermission = hasMenuPermission(item);

          if (item.children) {
            const filteredChildren = filterChildItems(item.children);
            const itemPermissionOk = (!item.requiredPermission && !item.requiredAnyPermissions?.length) || hasRequiredPermission;

            if (itemPermissionOk && filteredChildren.length > 0) {
              itemsAfterHeading.push({
                ...item,
                children: filteredChildren
              });
            } else if (hasRequiredPermission && filteredChildren.length === 0) {
              itemsAfterHeading.push({ ...item, children: [] });
            }
          } else if (hasRequiredPermission) {
            itemsAfterHeading.push(item);
          }
        }
      }

      if (currentHeading && itemsAfterHeading.length > 0) {
        filtered.push(currentHeading);
        filtered.push(...itemsAfterHeading);
      }

      return filtered;
    };

    return filterMenuItems(menu);
  }, [loading, user, hasPermission]);

  const isPathActive = (path?: string): boolean => {
    if (!path) return false;
    return location.pathname === path;
  };

  const hasActiveChild = (children?: MenuItem[]): boolean => {
    if (!children) return false;
    return children.some(child => isPathActive(child.path) || hasActiveChild(child.children));
  };

  const collectExpandableLabels = (items: MenuItem[]): string[] => {
    return items.flatMap((item) => {
      if (!item.children?.length) return [];
      return [item.label, ...collectExpandableLabels(item.children)];
    });
  };

  const toggleMenu = (label: string) => {
    if (collapsed) return;
    setExpandedMenus(prev =>
      prev.includes(label)
        ? prev.filter(item => item !== label)
        : [...prev, label]
    );
  };

  const toggleHeading = (label: string) => {
    if (collapsed) return;
    const isExpanding = !expandedHeadings.includes(label);
    setExpandedHeadings(prev =>
      prev.includes(label)
        ? prev.filter(item => item !== label)
        : [...prev, label]
    );

    // Auto-expand child menus within this heading section when expanding
    if (isExpanding) {
      const childLabels: string[] = [];
      let found = false;
      for (const menuItem of filteredMenuItems) {
        if (menuItem.isHeading && menuItem.label === label) {
          found = true;
          continue;
        }
        if (found && menuItem.isHeading) break;
        if (found && menuItem.children && menuItem.children.length > 0) {
          childLabels.push(menuItem.label);
        }
      }
      if (childLabels.length > 0) {
        setExpandedMenus(prev => Array.from(new Set([...prev, ...childLabels])));
      }
    }
  };

  const handleExpandAll = () => {
    if (collapsed) return;
    setExpandedHeadings(filteredMenuItems.filter((item) => item.isHeading).map((item) => item.label));
    setExpandedMenus(Array.from(new Set(collectExpandableLabels(filteredMenuItems))));
  };

  const handleCollapseAll = () => {
    if (collapsed) return;
    setExpandedHeadings([]);
    setExpandedMenus([]);
  };

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!user) return 'U';
    const first = user.first_name?.[0] || '';
    const last = user.last_name?.[0] || '';
    return (first + last).toUpperCase() || user.username?.[0]?.toUpperCase() || 'U';
  };

  const renderChildMenuItem = (item: MenuItem, index: number, depth = 0) => {
    const isActive = isPathActive(item.path);
    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedMenus.includes(item.label);
    const hasActiveChildren = hasActiveChild(item.children);
    const childPadding = 44 + depth * 16;
    const childContent = (
      <div
        style={{ paddingLeft: `${childPadding}px` }}
        className={`flex items-center justify-between py-2 pr-3 text-[11px] rounded-lg transition-colors duration-150
          ${isActive
            ? 'bg-blue-50 text-blue-800 font-semibold'
            : hasActiveChildren
              ? 'text-blue-800 bg-blue-50/40 font-semibold'
              : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900 font-medium'
          }`}
      >
        <div className="flex items-center min-w-0">
          {item.icon && (
            <item.icon className={`w-3.5 h-3.5 mr-2.5 flex-shrink-0 ${isActive ? 'text-blue-800' : 'text-gray-400'}`} />
          )}
          <span className="truncate">{item.label}</span>
        </div>
        {hasChildren && (
          <FiChevronDown
            className={`w-3.5 h-3.5 ml-2 flex-shrink-0 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
          />
        )}
      </div>
    );

    return (
      <li key={index}>
        {item.path && !hasChildren ? (
          <Link
            to={item.path}
            onClick={() => window.innerWidth < 1024 && onCloseMobile()}
          >
            {childContent}
          </Link>
        ) : (
          <button
            type="button"
            onClick={() => hasChildren && toggleMenu(item.label)}
            className="w-full text-left"
          >
            {childContent}
          </button>
        )}
        {hasChildren && (
          <div
            className={`overflow-hidden transition-all duration-200 ease-in-out ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <ul className="mt-0.5 space-y-0.5">
              {item.children?.map((child, childIndex) =>
                renderChildMenuItem(child, childIndex, depth + 1)
              )}
            </ul>
          </div>
        )}
      </li>
    );
  };

  const renderMenuItem = (item: MenuItem, index: number, currentHeading: string | null) => {
    // Render headings as collapsible section labels with icons
    if (item.isHeading) {
      if (collapsed) return null;
      const isHeadingExpanded = expandedHeadings.includes(item.label);
      return (
        <li key={index} className="pt-2.5 first:pt-0">
          <div className="mx-3 mb-0.5 border-t border-gray-100" />
          <button
            onClick={() => toggleHeading(item.label)}
            className={`flex items-center justify-between w-full px-3 py-1.5 text-sm font-semibold rounded-md transition-colors duration-150
              ${isHeadingExpanded
                ? 'text-gray-900 bg-gray-50'
                : 'text-gray-600 hover:text-gray-800'
              }`}
          >
            <div className="flex items-center">
              {item.icon && (
                <item.icon className={`w-5 h-5 mr-2.5 flex-shrink-0 ${isHeadingExpanded ? 'text-gray-800' : 'text-gray-500'}`} />
              )}
              <span>{item.label}</span>
            </div>
            <FiChevronDown className={`w-4 h-4 transition-transform duration-200 ${isHeadingExpanded ? 'rotate-180' : ''}`} />
          </button>
        </li>
      );
    }

    // Hide items if their heading section is collapsed
    if (currentHeading && !expandedHeadings.includes(currentHeading)) {
      return null;
    }

    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedMenus.includes(item.label);
    const isActive = isPathActive(item.path);
    const hasActiveChildren = hasActiveChild(item.children);

    // Build the menu item content
    const isStandaloneItem = item.isStandalone === true;
    const itemContent = (
      <div
        className={`group flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-colors duration-150
          ${isStandaloneItem ? 'text-sm font-semibold' : 'text-[12.5px] mx-1'}
          ${isActive
            ? 'bg-gradient-to-r from-blue-800 to-blue-900 text-white shadow-md'
            : hasActiveChildren
              ? 'text-blue-800 font-semibold bg-blue-50/50'
              : 'text-gray-800 hover:bg-gray-100 hover:text-gray-900'
          }
          ${collapsed ? 'justify-center !px-2.5' : ''}`}
        onClick={() => hasChildren ? toggleMenu(item.label) : undefined}
        title={collapsed ? item.label : ''}
      >
        <div className={`flex items-center min-w-0 ${collapsed ? 'justify-center' : ''}`}>
          {item.icon && (
            <item.icon className={`flex-shrink-0 ${collapsed ? '' : isStandaloneItem ? 'mr-2.5' : 'mr-3'} ${isActive ? 'text-white' : 'text-gray-500'} ${isStandaloneItem ? 'w-5 h-5' : 'w-4 h-4'}`} />
          )}
          {!collapsed && (
            <span className={`truncate ${isActive ? 'font-semibold' : 'font-medium'}`}>
              {item.label}
            </span>
          )}
        </div>

        {!collapsed && hasChildren && (
          <FiChevronDown
            className={`w-4 h-4 flex-shrink-0 ml-2 transition-transform duration-200
              ${isExpanded ? 'rotate-180' : ''}
              ${isActive ? 'text-white' : 'text-gray-400'}`}
          />
        )}

        {/* Tooltip for collapsed state */}
        {collapsed && (
          <div className="absolute left-full ml-3 px-2.5 py-1.5 bg-gray-800 text-white text-xs rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-[9999] pointer-events-none shadow-lg">
            {item.label}
            <div className="absolute left-0 top-1/2 -translate-x-1 -translate-y-1/2 w-2 h-2 bg-gray-800 rotate-45" />
          </div>
        )}
      </div>
    );

    return (
      <li key={index} className="relative">
        {item.path && !hasChildren ? (
          <Link
            to={item.path}
            onClick={() => window.innerWidth < 1024 && onCloseMobile()}
          >
            {itemContent}
          </Link>
        ) : (
          itemContent
        )}

        {/* Children dropdown */}
        {!collapsed && hasChildren && (
          <div
            className={`overflow-hidden transition-all duration-200 ease-in-out
              ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
          >
            <ul className="mt-0.5 space-y-0.5 mx-1">
              {item.children?.map((child, childIndex) =>
                renderChildMenuItem(child, childIndex)
              )}
            </ul>
          </div>
        )}
      </li>
    );
  };

  return (
    <>
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden transition-opacity duration-300"
          onClick={onCloseMobile}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 bg-white border-r border-gray-200 transform transition-all duration-300 ease-in-out lg:static lg:inset-0 flex flex-col
          ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
          ${collapsed ? 'w-[68px]' : 'w-64'}`}
      >
        {/* Header — Logo */}
        <div className={`flex items-center h-14 px-4 border-b border-gray-100 flex-shrink-0 ${collapsed ? 'justify-center' : 'justify-between'}`}>
          {!collapsed && (
            <img
              src="/assets/images/logo.png"
              alt="Eminence"
              className="h-10 object-contain"
            />
          )}
          {collapsed && (
            <img
              src="/assets/images/logo.png"
              alt="Eminence"
              className="h-7 w-7 object-contain"
            />
          )}

          {/* Mobile close */}
          <button
            onClick={onCloseMobile}
            className="lg:hidden flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>

        {/* Expand / Close All — kept outside the scrolling list so it stays
            reachable however far the menu is scrolled. */}
        {!collapsed && !loading && (
          <div className="px-5 py-1.5 flex items-center justify-end gap-3 border-b border-gray-100 bg-white flex-shrink-0">
            <button
              type="button"
              onClick={handleExpandAll}
              className="text-[11px] font-medium text-blue-800 hover:text-blue-900"
            >
              Expand All
            </button>
            <button
              type="button"
              onClick={handleCollapseAll}
              className="text-[11px] font-medium text-gray-600 hover:text-gray-800"
            >
              Close All
            </button>
          </div>
        )}

        {/* Navigation */}
        <nav className={`flex-1 min-h-0 py-3 ${collapsed ? 'overflow-visible' : 'overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 hover:scrollbar-thumb-gray-300 scrollbar-track-transparent'}`}>
          {loading ? (
            <MenuSkeleton />
          ) : (
            <>
              <ul
                className={`space-y-0.5 px-2
                  ${collapsed
                    ? 'overflow-visible'
                    : ''
                  }`}
              >
                {(() => {
                  let currentHeading: string | null = null;
                  return filteredMenuItems.map((item, index) => {
                    if (item.isHeading) {
                      currentHeading = item.label;
                    } else if (item.isStandalone) {
                      currentHeading = null;
                    }
                    return renderMenuItem(item, index, currentHeading);
                  });
                })()}
              </ul>
            </>
          )}
        </nav>

        {/* Footer — User info + Logout */}
        <div className="border-t border-gray-100 flex-shrink-0">
          {/* User info */}
          {/* {!collapsed && user && (
            <div className="flex items-center px-4 py-3 space-x-3">
              <div className="w-8 h-8 rounded-full bg-blue-900 flex items-center justify-center flex-shrink-0">
                <span className="text-white text-xs font-semibold">{getUserInitials()}</span>
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-800 truncate">
                  {user.first_name} {user.last_name}
                </p>
                <p className="text-xs text-gray-400 truncate">{user.email}</p>
              </div>
            </div>
          )} */}

        </div>
      </aside>
    </>
  );
};

export default Sidebar;
